import { useRouter } from './useRouter';

export const useReturnParams = () => {
  const { infoFromCurrentPath } = useRouter();

  const returnBreed: string[] | undefined = infoFromCurrentPath.params?.length
    ? [decodeURI(infoFromCurrentPath.params[0])]
    : undefined;
  const returnSearch = infoFromCurrentPath.search;

  return { returnBreed, returnSearch };
};
